export const GENERIC_RESOURCE = 'generic_resource';

export const RESOURCE_DOCUMENT = {
  emailCsvResource: 'email_csv_resource',
  emailSubjectLineCsvResource: 'email_subject_csv_resource',
  emailPromotionCsvResource: 'email_promotion_csv_resource',
  emailColdCsvResource: 'email_cold_csv_resource',
  googleDocs: 'google_docs',
};

export const EMAIL_CSV_RESOURCE_DOCUMENTS = [
  RESOURCE_DOCUMENT.emailSubjectLineCsvResource,
  RESOURCE_DOCUMENT.emailPromotionCsvResource,
  RESOURCE_DOCUMENT.emailColdCsvResource,
];

export const isEmailCsvResourceDocument = (resourceDocument) =>
  EMAIL_CSV_RESOURCE_DOCUMENTS.includes(resourceDocument);

export const RESOURCE_DOCUMENT_PROPS = {
  [RESOURCE_DOCUMENT.emailCsvResource]: {
    label: 'Email performance report',
  },
  [RESOURCE_DOCUMENT.emailSubjectLineCsvResource]: {
    label: 'Email - Subject Line performance report',
  },
  [RESOURCE_DOCUMENT.emailPromotionCsvResource]: {
    label: 'Email - Promotion performance report',
  },
  [RESOURCE_DOCUMENT.emailColdCsvResource]: {
    label: 'Email - Cold performance report',
  },
  [RESOURCE_DOCUMENT.googleDocs]: {
    label: 'Google docs',
  },
};

export const getResourceDocumentLabel = (document) => RESOURCE_DOCUMENT_PROPS[document]?.label;
